<main class="main__container">
    <h1 class="title">{{"Feed" | translate }}</h1>

    <div class="filter">
		<div class="divider"></div>
		<div class="filter-item">
			<span>{{"Show" | translate }}:</span>
			<mat-form-field>
				<mat-select
					#filter
                    [(value)]="selectedView"
                    (valueChange)="onViewChanged()"
				>
					<mat-option value="All">{{"All Posts" | translate }}</mat-option>
					<span *ngIf="youthWorkersData != null">
						<mat-option value="My">{{"My Youth Worker's Posts" | translate}}</mat-option>
					</span>
					
				</mat-select>
			</mat-form-field>
		</div>
	</div>

	<div *ngIf="feeds != null">
		<app-post-feed 
			*ngFor="let feed of feeds" 
			[post]="feed" 
			[postParticipant]="getFeedParticipant(feed)" 
			class="news-feed"
    	>

    	</app-post-feed>
	</div>
    
</main>

